module.exports = __webpack_public_path__ + "static/media/Branding-SF-Bold.12df7a07.otf";